import "@/index.css";
import "@/styles/dsl.css";
import { AuthProvider, useAuth } from "@/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import Login from "@/pages/Login";
import MainApp from "@/pages/MainApp";

function Shell() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="dsl-login-shell" data-testid="auth-checking">
        <div style={{ color: "var(--text-dim)", fontFamily: "'IBM Plex Mono', monospace", fontSize: 12 }}>
          Loading…
        </div>
      </div>
    );
  }
  if (!user) return <Login />;
  return <MainApp />;
}

export default function App() {
  return (
    <ConfirmProvider>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </ConfirmProvider>
  );
}
